export default __webpack_public_path__ + "static/media/sc2.471e58af.jpg";